import { useEffect, useState } from "react";
import stringHelpers from "../../utilities/stringHelpers";
import { ErrorModal } from "../../utilities/errorModal";
import Api from '../api/api';
import { WarningModal } from "../shared/warningModal";

export const GlobalSettings = ({ user, token }) => {
    const [kadoeInEdit, setKadoeInEdit] = useState(false);
    const [kadoeUsername, setKadoeUsername] = useState("");
    const [kadoePassword, setKadoePassword] = useState("");
    const [kadoeApiKey, setKadoeApiKey] = useState("");
    const [kadoeLinkProviderId, setKadoeLinkProviderId] = useState("");

    const [kadoeEnhancedInEdit, setKadoeEnhancedInEdit] = useState(false)
    const [kadoeEnhancedUsername, setKadoeEnhancedUsername] = useState("");
    const [kadoeEnhancedPassword, setKadoeEnhancedPassword] = useState("");
    const [kadoeEnhancedApiKey, setKadoeEnhancedApiKey] = useState("");
    const [kadoeEnhancedLinkProviderId, setKadoeEnhancedLinkProviderId] = useState("");

    const [showRegenerateKadoePasswordModal, setShowRegenerateKadoePasswordModal] = useState(false)
    const [showRegenerateKadoeEnhancedPasswordModal, setShowRegenerateKadoeEnhancedPasswordModal] = useState(false)
    const [showRegenerateKadoeApiKeyModal, setShowRegenerateKadoeApiKeyModal] = useState(false)
    const [showRegenerateKadoeEnhancedApiKeyModal, setShowRegenerateKadoeEnhancedApiKeyModal] = useState(false)
    const [settings, setSettings] = useState(null);

    const [errorMessage, setErrorMessage] = useState("");
    const isGlobalAdmin = user.isGlobalAdmin;

    const getGlobalSettings = () => {
        Api.getGlobalSettings(
            data => setSettings(data),
            error => console.log(error),
            token
        )
    }

    const generateNewKadoePassword = () => {
        Api.generateGlobalKadoePassword(
            data => {
                if (data.isError) {
                    setErrorMessage(data.errorMessage)
                } else {
                    getGlobalSettings()
                }
            },
            error => setErrorMessage(error.errorMessage),
            token
        )
    }

    const generateNewKadoeEnhancedPassword = () => {
        Api.generateGlobalKadoeEnhancedPassword(
            data => {
                if (data.isError) {
                    setErrorMessage(data.errorMessage)
                } else {
                    getGlobalSettings()
                }
            },
            error => setErrorMessage(error.errorMessage),
            token
        )
    }

    const generateNewKadoeApiKey = () => {
        Api.generateGlobalKadoeApiKey(
            data => {
                if (data.isError) {
                    setErrorMessage(data.errorMessage)
                } else {
                    getGlobalSettings()
                }
            },
            error => setErrorMessage(error.errorMessage),
            token
        )
    }

    const generateNewKadoeEnhancedApiKey = () => {
        Api.generateGlobalKadoeEnhancedApiKey(
            data => {
                if (data.isError) {
                    setErrorMessage(data.errorMessage)
                } else {
                    getGlobalSettings()
                }
            },
            error => setErrorMessage(error.errorMessage),
            token
        )
    }

    const edit = () => {
        Api.editGlobalSettings(
            kadoeUsername, kadoePassword, kadoeApiKey, kadoeLinkProviderId,
            kadoeEnhancedUsername, kadoeEnhancedPassword, kadoeEnhancedApiKey, kadoeEnhancedLinkProviderId,
            data => {
                if (data.isError) {
                    setErrorMessage(data.errorMessage)
                } else {
                    setSettings(data)
                    setKadoeInEdit(false)
                    setKadoeEnhancedInEdit(false)
                }
            },
            error => {
                console.log(error)
                setErrorMessage(error.message)
            },
            token
        )
    }

    useEffect(() => getGlobalSettings(), [])

    useEffect(() => {
        if (settings !== null) {
            setKadoeUsername(!stringHelpers.isNullOrEmpty(settings.kadoeUsername) ? settings.kadoeUsername : "")
            setKadoeApiKey(!stringHelpers.isNullOrEmpty(settings.kadoeApiKey) ? settings.kadoeApiKey : "")
            setKadoePassword(!stringHelpers.isNullOrEmpty(settings.kadoePassword) ? settings.kadoePassword : "")
            setKadoeLinkProviderId(!stringHelpers.isNullOrEmpty(settings.kadoeLinkProviderId) ? settings.kadoeLinkProviderId : "")
            setKadoeEnhancedUsername(!stringHelpers.isNullOrEmpty(settings.kadoeEnhancedUsername) ? settings.kadoeEnhancedUsername : "")
            setKadoeEnhancedPassword(!stringHelpers.isNullOrEmpty(settings.kadoeEnhancedPassword) ? settings.kadoeEnhancedPassword : "")
            setKadoeEnhancedApiKey(!stringHelpers.isNullOrEmpty(settings.kadoeEnhancedApiKey) ? settings.kadoeEnhancedApiKey : "")
            setKadoeEnhancedLinkProviderId(!stringHelpers.isNullOrEmpty(settings.kadoeEnhancedLinkProviderId) ? settings.kadoeEnhancedLinkProviderId : "")
        }
    }, [settings])

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <div className="card mb-3">
                        <div className="card-header">
                            <div className="row align-items-center px-3">
                                <h5 className="mb-0">Global Settings</h5>
                            </div>
                        </div>
                    </div>
                    <div className="card mb-3">
                        <div className="card-header">
                            <div className="row align-items-center">
                                <div className="col">
                                    <h5 className="mb-0">KADOE</h5>
                                </div>
                                <div className="col-auto">
                                    <button type="button" className="btn btn-primary btn-sm ml-2" onClick={ () => {
                                        if (kadoeInEdit) {
                                            setKadoeApiKey(settings.kadoeApiKey);
                                            setKadoeUsername(settings.kadoeUsername);
                                            setKadoePassword(settings.kadoePassword);
                                            setKadoeLinkProviderId(settings.kadoeLinkProviderId)
                                        }
                                        setKadoeInEdit(!kadoeInEdit)
                                    }
                                    }>
                                        <i className="fas fa-edit mr-1"></i>Edit</button>
                                </div>
                            </div>
                        </div>
                        <div className="card-body bg-light border-top details-container">
                            {
                                !kadoeInEdit &&
                                <>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold  mb-3">Username</p>
                                        </div>
                                        <div className="col-md-6 col-12 ">{ kadoeUsername }</div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold  mb-3">Password</p>
                                        </div>
                                        <div className="col-md-6 col-12 ">{ kadoePassword }</div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold  mb-3">API Key</p>
                                        </div>
                                        <div className="col-md-6 col-12 ">{ kadoeApiKey }</div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold  mb-3">Link Provider ID</p>
                                        </div>
                                        <div className="col-md-6 col-12 ">{ kadoeLinkProviderId }</div>
                                    </div>
                                </>
                            }
                            {
                                kadoeInEdit &&
                                <>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold mb-1">Username</p>
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <div className="form-group mb-0">
                                                <input className="form-control mb-1" type="text" value={ kadoeUsername } onChange={ (e) => setKadoeUsername(e.target.value) } />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold mb-1">Password</p>
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <div className="mb-0 input-group">
                                                <input readOnly className="border rounded-left mb-1 form-control-plaintext px-3 bg-white" type="text" value={ kadoePassword } />
                                                <div className="input-group-append">
                                                    <button onClick={ () => setShowRegenerateKadoePasswordModal(true) } className="btn btn-falcon-default btn-sm py-3 d-flex align-items-center" disabled={ !isGlobalAdmin }><i className='fas fa-undo'></i></button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold mb-1">API Key</p>
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <div className="input-group mb-0">
                                                <input readOnly className="border rounded-left form-control mb-1 form-control-plaintext px-3 bg-white" type="text" value={ kadoeApiKey } />
                                                <div className="input-group-append">
                                                    <button onClick={ () => setShowRegenerateKadoeApiKeyModal(true) } className="btn btn-falcon-default btn-sm py-3 d-flex align-items-center" disabled={ !isGlobalAdmin }><i className='fas fa-undo'></i></button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold mb-1">Link Provider ID</p>
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <div className="form-group mb-0">
                                                <input className="form-control mb-1" type="text" value={ kadoeLinkProviderId } onChange={ (e) => setKadoeLinkProviderId(e.target.value) } />
                                            </div>
                                        </div>
                                    </div>
                                </>
                            }

                        </div>
                        {
                            kadoeInEdit &&
                            <div className="card-footer border-top ">
                                <div className="row client-edit-buttons">
                                    <div className="col-12 col-sm-auto ml-auto  pl-0">
                                        <div id="dashboard-actions">
                                            <button type="button" className="btn btn-falcon-default btn-sm ml-2" onClick={ () => {
                                                setKadoeApiKey(settings.kadoeApiKey);
                                                setKadoeUsername(settings.kadoeUsername);
                                                setKadoePassword(settings.kadoePassword);
                                                setKadoeLinkProviderId(settings.kadoeLinkProviderId)
                                                setKadoeInEdit(false);
                                            } }>
                                                <i className="fas fa-times mr-1"></i>Cancel</button>
                                            <button type="button" className="btn btn-success btn-sm ml-2" onClick={ () => edit() }>
                                                <i className="fas fa-check mr-1"></i>Confirm</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                    <div className="card mb-3">
                        <div className="card-header">
                            <div className="row align-items-center">
                                <div className="col">
                                    <h5 className="mb-0">KADOE (Enhanced)</h5>
                                </div>
                                <div className="col-auto">
                                    <button type="button" className="btn btn-primary btn-sm ml-2" onClick={ () => {
                                        if (kadoeEnhancedInEdit) {
                                            setKadoeEnhancedUsername(settings.kadoeEnhancedUsername)
                                            setKadoeEnhancedPassword(settings.kadoeEnhancedPassword)
                                            setKadoeEnhancedApiKey(settings.kadoeEnhancedApiKey)
                                            setKadoeEnhancedLinkProviderId(settings.kadoeEnhancedLinkProviderId)
                                        }
                                        setKadoeEnhancedInEdit(!kadoeEnhancedInEdit)
                                    }
                                    }>
                                        <i className="fas fa-edit mr-1"></i>Edit</button>
                                </div>
                            </div>
                        </div>
                        <div className="card-body bg-light border-top details-container">
                            {
                                !kadoeEnhancedInEdit &&
                                <>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold  mb-3">Username</p>
                                        </div>
                                        <div className="col-md-6 col-12 ">{ kadoeEnhancedUsername }</div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold  mb-3">Password</p>
                                        </div>
                                        <div className="col-md-6 col-12 ">{ kadoeEnhancedPassword }</div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold  mb-3">API Key</p>
                                        </div>
                                        <div className="col-md-6 col-12 ">{ kadoeEnhancedApiKey }</div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold  mb-3">Link Provider ID</p>
                                        </div>
                                        <div className="col-md-6 col-12 ">{ kadoeEnhancedLinkProviderId }</div>
                                    </div>
                                </>
                            }
                            {
                                kadoeEnhancedInEdit &&
                                <>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold mb-1">Username</p>
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <div className="form-group mb-0">
                                                <input className="form-control mb-1" type="text" value={ kadoeEnhancedUsername } onChange={ (e) => setKadoeEnhancedUsername(e.target.value) } />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold mb-1">Password</p>
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <div className="mb-0 input-group">
                                                <input readOnly className="border rounded-left mb-1 form-control-plaintext px-3 bg-white" type="text" value={ kadoeEnhancedPassword } />
                                                <div className="input-group-append">
                                                    <button onClick={ () => setShowRegenerateKadoeEnhancedPasswordModal(true) } className="btn btn-falcon-default btn-sm py-3 d-flex align-items-center" disabled={ !isGlobalAdmin }><i className='fas fa-undo'></i></button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold mb-1">API Key</p>
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <div className="input-group mb-0">
                                                <input readOnly className="border rounded-left form-control mb-1 form-control-plaintext px-3 bg-white" type="text" value={ kadoeEnhancedApiKey } />
                                                <div className="input-group-append">
                                                    <button onClick={ () => setShowRegenerateKadoeEnhancedApiKeyModal(true) } className="btn btn-falcon-default btn-sm py-3 d-flex align-items-center" disabled={ !isGlobalAdmin }><i className='fas fa-undo'></i></button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold mb-1">Link Provider ID</p>
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <div className="form-group mb-0">
                                                <input className="form-control mb-1" type="text" value={ kadoeEnhancedLinkProviderId } onChange={ (e) => setKadoeEnhancedLinkProviderId(e.target.value) } />
                                            </div>
                                        </div>
                                    </div>
                                </>
                            }
                        </div>
                        {
                            kadoeEnhancedInEdit &&
                            <div className="card-footer border-top ">
                                <div className="row client-edit-buttons">
                                    <div className="col-12 col-sm-auto ml-auto  pl-0">
                                        <div id="dashboard-actions">
                                            <button type="button" className="btn btn-falcon-default btn-sm ml-2" onClick={ () => {
                                                setKadoeEnhancedUsername(settings.kadoeEnhancedUsername)
                                                setKadoeEnhancedPassword(settings.kadoeEnhancedPassword)
                                                setKadoeEnhancedApiKey(settings.kadoeEnhancedApiKey)
                                                setKadoeEnhancedLinkProviderId(settings.kadoeEnhancedLinkProviderId)
                                                setKadoeEnhancedInEdit(false);
                                            } }>
                                                <i className="fas fa-times mr-1"></i>Cancel</button>
                                            <button type="button" className="btn btn-success btn-sm ml-2" onClick={ () => edit() }>
                                                <i className="fas fa-check mr-1"></i>Confirm</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>

            { showRegenerateKadoePasswordModal &&
                <WarningModal
                    message="This will generate a new Kadoe password. Are you sure?"
                    onHide={ () => setShowRegenerateKadoePasswordModal(false) }
                    onConfirm={ () => { setShowRegenerateKadoePasswordModal(false); generateNewKadoePassword() } }
                />
            }

            { showRegenerateKadoeEnhancedPasswordModal &&
                <WarningModal
                    message="This will generate a new Kadoe (Enhanced) password. Are you sure?"
                    onHide={ () => setShowRegenerateKadoeEnhancedPasswordModal(false) }
                    onConfirm={ () => { setShowRegenerateKadoeEnhancedPasswordModal(false); generateNewKadoeEnhancedPassword() } }
                />
            }

            { showRegenerateKadoeApiKeyModal &&
                <WarningModal
                    message="This will generate a new Kadoe API key. Are you sure?"
                    onHide={ () => setShowRegenerateKadoeApiKeyModal(false) }
                    onConfirm={ () => { setShowRegenerateKadoeApiKeyModal(false); generateNewKadoeApiKey() } }
                />
            }

            { showRegenerateKadoeEnhancedApiKeyModal &&
                <WarningModal
                    message="This will generate a new Kadoe (Enhanced) API key. Are you sure?"
                    onHide={ () => setShowRegenerateKadoeEnhancedApiKeyModal(false) }
                    onConfirm={ () => { setShowRegenerateKadoeEnhancedApiKeyModal(false); generateNewKadoeEnhancedApiKey() } }
                />
            }
            { !stringHelpers.isNullOrEmpty(errorMessage) && <ErrorModal message={ errorMessage } onHide={ () => setErrorMessage("") } /> }
        </div>
    )
}
